/**
 * Change styles to difference wide cards.
 */
 function difference_wide_cards(){
    const elements = document.querySelectorAll(".solutions-row-container");  
    if(elements.length){
        elements.forEach(function(container){
            var dataValue = $(container).data('wideCards');
                if (dataValue != 'True') {
                    $('.card-loomis-difference').addClass('card-loomis-difference--alt');
                    $('.card-loomis-difference__img').addClass('card-loomis-difference__img--alt');
                }
        });
    }
}

difference_wide_cards();

export default difference_wide_cards;